import { Capacitor } from '@capacitor/core';
import { BiometricAuth } from '@aparajita/capacitor-biometric-auth';

// Bloqueo biométrico local (Face ID / Touch ID / huella) sobre la sesión ya
// guardada. No sustituye al login: es un candado del dispositivo. Las preferencias
// son banderas no sensibles, así que van en localStorage.

const LOCK_ENABLED_KEY = 'biometric_lock_enabled';
const PROMPT_SEEN_KEY = 'biometric_prompt_seen';

export const isNative = (): boolean => Capacitor.isNativePlatform();

export const isBiometricLockEnabled = (): boolean =>
  localStorage.getItem(LOCK_ENABLED_KEY) === '1';

export const setBiometricLockEnabled = (enabled: boolean): void => {
  localStorage.setItem(LOCK_ENABLED_KEY, enabled ? '1' : '0');
};

export const isBiometricPromptSeen = (): boolean =>
  localStorage.getItem(PROMPT_SEEN_KEY) === '1';

export const markBiometricPromptSeen = (): void => {
  localStorage.setItem(PROMPT_SEEN_KEY, '1');
};

// ¿El dispositivo tiene biometría disponible y configurada?
export const isBiometryAvailable = async (): Promise<boolean> => {
  if (!isNative()) return false;
  try {
    const result = await BiometricAuth.checkBiometry();
    return result.isAvailable;
  } catch {
    return false;
  }
};

// Lanza la biometría. Devuelve true si el usuario se autentica, false si falla
// o cancela. No lanza excepción hacia arriba.
export const runBiometricAuth = async (reason: string): Promise<boolean> => {
  try {
    await BiometricAuth.authenticate({
      reason,
      cancelTitle: 'Cancelar',
      allowDeviceCredential: true, // permite el código del dispositivo como respaldo
      androidTitle: 'Desbloquear MalDolor',
      androidSubtitle: reason,
    });
    return true;
  } catch {
    return false;
  }
};
